// Async import để Module Federation hoạt động đúng (tránh eager loading)
import('./bootstrap')

export {}
